export const LOG_TRACE_HEADER = {
  BUSINESS_TX_ID: 'x-od-business-tx-id',
  TRACE_ID: 'x-od-trace-id',
};
